/**
 * Reads a design token, resolved to the value a canvas can use.
 *
 * A canvas takes colours, not custom properties — `ctx.fillStyle` and Fabric's
 * options cannot hold `var(--color-error-500)`. Anything drawn rather than
 * styled therefore has to read the token instead of referencing it, and this
 * is the one place that happens, so the drawn surfaces stay on the same
 * palette as everything around them.
 *
 * The fallback is the token's own current value. A stylesheet that failed to
 * load then degrades to the right colour rather than to nothing.
 */
export function paletteColour(token: string, fallback: string): string {
  if (typeof getComputedStyle !== 'function') return fallback;

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(token)
    .trim();

  return value || fallback;
}
